"use client";

import { ChevronDoubleDownIcon } from "@heroicons/react/24/solid";
import { Link } from "react-scroll";

const ScrollDown = ({ id }: { id: string }) => {
  return (
    <div className="absolute bottom-0 left-0 flex h-24 w-full items-end justify-center bg-gradient-to-t from-slate-900 to-transparent p-5 lg:hidden">
      <Link
        to={id}
        smooth={true}
        duration={500}
        className="cursor-pointer font-Satoshi-Light text-lg text-white"
      >
        <ChevronDoubleDownIcon className="h-10 w-10 animate-bounce" />
      </Link>
    </div>
  );
};

export default ScrollDown;
